import { render, staticRenderFns } from "./DispatcherReportCard.vue?vue&type=template&id=25fd4348&scoped=true&"
import script from "./DispatcherReportCard.vue?vue&type=script&lang=js&"
export * from "./DispatcherReportCard.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherReportCard.vue?vue&type=style&index=0&id=25fd4348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd4348",
  null
  
)

export default component.exports